import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Badge from '@material-ui/core/Badge';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { useDispatch } from 'react-redux';
import { togglePreferencesModalAction } from '../../redux/actions/appActions';
import { useTranslation } from 'react-i18next';

export default function ProfileOptionsBody({ handleLogout, classes }) {
  const dispatch: any = useDispatch();

  const openPreferencesModal = () => {
    dispatch(togglePreferencesModalAction());
  };

  const { t } = useTranslation();

  return (
    <List
      component="nav"
      className={classes.profileOptionsBody}
      aria-label="mailbox folders"
    >
      <ListItem button>
        <NotificationImportantIcon />
        &nbsp;
        <ListItemText primary={t('app.menu.notifications')} />
        <Badge badgeContent={0} color="primary"></Badge>
      </ListItem>

      <ListItem button onClick={openPreferencesModal}>
        <SettingsIcon />
        &nbsp;
        <ListItemText primary={t('app.menu.preferences')} />
      </ListItem>
      <ListItem button>
        <OpenInNewIcon />
        &nbsp;
        <ListItemText primary={t('app.menu.resources')} />
      </ListItem>
      <ListItem button onClick={handleLogout}>
        <ExitToAppIcon />
        &nbsp;
        <ListItemText primary={t('app.menu.logout')} />
      </ListItem>
    </List>
  );
}
